import React, { useEffect, useState } from "react";
import { NewspaperIcon } from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchPosts } from "../../features/admin/PostsSlice";
import { fetchCategoryByType } from "../../features/admin/CategorySlice";

const animation = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  exit: { opacity: 0, y: 10, transition: { duration: 0.2 } },
};

const AdminPostCreatedStatisticCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  // Lấy từ redux store
  const { authPosts: posts, authPostStatus: status } = useSelector(
    (state) => state.posts,
  );
  const { categories } = useSelector((state) => state.categories);

  const [approved, setApproved] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchPosts());
    }
    dispatch(fetchCategoryByType("notification,navbar,post,"));
  }, [dispatch, status]);

  useEffect(() => {
    if (!posts || !categories) return;
    const filtered = posts
      .filter(
        (post) =>
          userId == 1 ||
          categories.some((category) => category.id === post.categoryId),
      )
      .filter((post) => post.type !== "notification");

    setTotal(filtered.length);
    setApproved(filtered.filter((p) => p.status === "published").length);
  }, [posts, categories, userId]);

  return (
    <motion.div
      {...animation}
      whileHover={{ scale: 1.03 }}
      className="w-full shadow-md sm:w-auto flex flex-col items-center text-center p-5 rounded-2xl border border-blue-100 bg-gradient-to-br from-white to-blue-50/30 hover:border-blue-200 transition-all cursor-pointer"
      onClick={() => navigate("/admin/posts")}
    >
      <div className="p-3 bg-blue-100 rounded-full mb-3 flex items-center justify-center">
        <NewspaperIcon className="h-6 w-6 text-blue-600" />
      </div>
      <p className="text-lg text-black mb-1">Bài viết đã được duyệt</p>
      <p className="text-3xl font-bold text-black">
        <span>{approved}</span>
        <span className="text-3xl font-bold"> / </span>
        <span>{total}</span>
      </p>
    </motion.div>
  );
};

export default AdminPostCreatedStatisticCard;
